import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Tooltip, Typography } from 'src/components/common';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import { colors } from 'src/constants';
import { textEllipsis, timeAgo } from 'src/utils';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { markChatAsRead, resetMessages, updateOneToOneRecipientUser } from 'src/store/chat/chat.slice';
import { TUserTypes } from 'src/constants/user.constants';

import { TChatListUserCardProps } from './chatListUserCard.types';
import './chatListUserCard.scss';
import Entrepreneur from 'src/assets/images/svg/Entrepreneur.svg';
import MentorBadge from 'src/assets/images/svg/MentorBadge.svg';
import IncubatorBadge from 'src/assets/images/svg/IncubatorBadge.svg';
import Company from 'src/assets/images/svg/Company.svg';
import { socketService } from 'src/services/socket.api.service';
import { set } from 'lodash';

const ChatListUserCard: FC<TChatListUserCardProps> = ({
  selectedUserId,
  selectedUserType,
  loggedInUserType,
  authenticatedId,
  ...user
}: TChatListUserCardProps) => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    oneToOneChatLists,
    Groups: groupList
  } = useAppSelector((store) => store.chat);
  const userDetail = user?.Users?.[0];
  const companyDetail = user?.Companies?.[0];
  // Constantsj

  const userId: any = userDetail?.id ? userDetail?.id : companyDetail?.id;
  const userType: TUserTypes = userDetail?.id ? 'User' : 'Company';
  const isUserSelected = userId === selectedUserId && selectedUserType === userType;

  const id: string = userType === 'User' ? userDetail?.id : companyDetail?.id;
  const name: string = userType === 'User' ? userDetail?.name : companyDetail?.name;
  const role: string = userType === 'User' ? userDetail?.role : companyDetail?.type;
  const profilePic: string = userType === 'User' ? userDetail?.profilePic : companyDetail?.logo;

  const nameWithEllipsis = textEllipsis({ charLimit: 12, text: name });
  const [individualCount, setIndividualCount] = useState<number>(user?.unreadMessageCount || 0);

  const handleOpenChatWindow = () => {
    if (!isUserSelected) {
      // user.unreadMessageCount= 0;
      // Function to emit the update-last-visited event
      function updateLastVisited(conversationId, userType, userId) {
        socketService.emit("update-last-visited", {
          conversationId,
          userType, // EnumUserType.USER or EnumUserType.COMPANY
          userId
        });
      }
      updateLastVisited(user?.id, loggedInUserType, authenticatedId);
      setIndividualCount(0);
      console.log('Socket connected!->>>>');
      socketService.emit("count-unread-users", {
        userId: authenticatedId,
        userType: loggedInUserType
      });
      dispatch(resetMessages());
      // Dispatch action to reset unread count for this chat
      // dispatch(markChatAsRead({ chatId: user?.id }));
      const path = `${window.location.pathname}?conversationId=${user?.id}&userType=${userType}&userId=${userId}`;
      navigate(path);
      // const performAction = (userId, userType) => {
      //         const userIds = [userId];
      //         socketService.emit("notifications-unread", {
      //           userIds,
      //           userType: userType
      //         });
      //       };
      //       performAction(user?.id, userType);
    }
  };

  useEffect(() => {
    // const handleLastVisitedUpdated = (data: { 
    //   conversationId: string; 
    //   unreadCount: number 
    // }) => {
    //   console.log("lastCall>>>>>>>>>>>>>>>>>", data);
    //   if (data.conversationId === user?.id) {
    //     setIndividualCount(data.unreadCount);
    //   }
    // };

    const handleMessageRead = (data) => {
      console.log("messageRead>>>>>>>>>>>>>>>>>", data);
      if (data.conversationId === user?.id) {
        console.log("messageRead>>>>>>>>>>>>>>>>>33333", data);
        setIndividualCount(data.unreadCount);
      }
      // setIndividualCount(data.unreadCount);
    };

    const handleLatestCount = (data) => {
      console.log("lastCount>>>>>>>>>>>>>>>>>", data);
      if (data.conversationId === user?.id) {
        console.log("lastCount>>>>>>>>>>>>>>>>>444", data);
        setIndividualCount(data.unreadCount + 1);
      }
      // setIndividualCount(data.unreadCount);
    };

    // Listen for socket events
    // socketService.on("last-visited-updated", handleLastVisitedUpdated);
    socketService.on("last-count", handleLatestCount);
    socketService.on("message-read", handleMessageRead);

    // Clean up listeners when component unmounts
    return () => {
      // socketService.off("last-visited-updated", handleLastVisitedUpdated);
      socketService.off("last-count", handleLatestCount);
      socketService.off("message-read", handleMessageRead);
    };
  }, [user?.id]);

  const updateSelectedUser = () => {
    const selectedUser = {
      id,
      name,
      role,
      profilePic
    };

    dispatch(updateOneToOneRecipientUser(selectedUser));
  };

  useEffect(() => {
    if (isUserSelected) {
      updateSelectedUser();
    }
  }, [selectedUserId]);

  return (
    <div
      className={classNames('chat-list-user-card', {
        'chat-list-user-card--is-selected': isUserSelected
      })}
      onClick={handleOpenChatWindow}
    >
      <div className="chat-list-user-card__left">
        <ProfilePicture url={profilePic} fallback={name?.slice(0, 1)} />
        <div className="chat-list-user-card__left__user-details">
          <Tooltip text={name} conditionToDisplay={nameWithEllipsis?.hasEllipsis} limitWidth>
            <Typography
              as="p"
              variant="body-2"
              fontWeight="medium"
              className="namePerson"
            // style={{ color: colors?.neutral?.[1100] }}
            >
              {nameWithEllipsis?.text}
              {(role === "Aspiring Entrepreneur" || role === "Entrepreneur") && (<img style={{ marginLeft: "8px", height: "20px", width: "20px", marginBottom: "2px" }} src={Entrepreneur} alt="  Entrepreneur" />)}
              {(role === "Mentor" || role === "Investor") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={MentorBadge} alt="Mentor/Investor" />)}
              {(role === "Incubator" || role === "Accelerator" || role === "E-Cell") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={IncubatorBadge} alt="IncubatorBadge" />)}
              {(role === "Start up" || role === "Service Provider") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={Company} alt="Company" />)}
            </Typography>
          </Tooltip>
          {(role === "Mentor" || role === "Investor" || role === "Start up" || role === "Service Provider" || role === "Incubator" || role === "E-Cell" || role === "Accelerator") && (<Typography
            as="p"
            variant="caption"
            fontWeight="regular"
            className='profileRole'
          // style={{ color: colors?.neutral?.[900] }}
          >
            {role}
          </Typography>)}
        </div>
      </div>
      <div className="chat-list-user-card__right">
        <Typography
          as="span"
          variant="caption"
          fontWeight="semiBold"
          className={classNames('chat-list-user-card__right__unread-count', {
            'chat-list-user-card__right__unread-count--is-hidden': individualCount < 1
          })}
        >
          {/* {user?.unreadMessageCount} */}
          {individualCount > 0 && (individualCount)}
        </Typography>
        <Typography
          as="p"
          variant="caption"
          fontWeight="regular"
          style={{ color: colors?.neutral?.[700] }}
          className="chat-list-user-card__right__updated-at"
        >
          {timeAgo({ timestamp: user?.updatedAt })}
        </Typography>
      </div>
    </div>
  );
};

export default ChatListUserCard;
